<div class="myField {{highlight}}" 
    [ngClass]="{
        'highlight': active,
        'd-inline-block': !show.label && fieldOptions?.displayType !== 'map',
        'd-block': (show.value && fieldOptions?.cssClass !== 'd-inline-block') || fieldOptions?.displayType === 'map'
    }">

    <h6 *ngIf="show?.label === true">
        {{field?.UILabel || field?.DisplayText || 'No title'}}
        <span>
            <button #changesEl
                *ngIf="historical.length"
                class="btn btn-sm cv-btn-revised_fields"
                (click)="showHistorical()"
            >
                <i class="fas fa-book"></i>
                <span>{{ historical.length }}</span>
            </button>
        </span>
    </h6>
    <div *ngIf="show?.label === false">
        <button #changesEl
            *ngIf="historical.length"
            class="btn btn-sm cv-btn-revised_fields"
            (click)="showHistorical()"
        >
            <i class="fas fa-book"></i>
            <span>{{ historical.length }}</span>
        </button>
    </div>

    <div *ngIf="fieldOptions?.displayType !== 'map' && show.value && field">
        <div class="form-group">
            <ng-container [ngSwitch]="field.DataType">
                <ng-container *ngSwitchCase="field.DataType === 'Enumerated' || field.DataType === 'Enumeration' ? field.DataType : '' ">
                    <cv-cascader
                        [items]="field.Enumeration | enumerationExclude"
                        [configOptions]="{value: 'Key', text: 'Value', children: 'Children'}"
                        placeholder=""
                        [value]="control.value"
                        [valid]="!(this.control.touched && this.control.invalid)"
                        [disabled]="false"
                        (valueChange)="cascadeChanged($event)">
                    </cv-cascader>
                </ng-container>

                <ng-container *ngSwitchCase="'Boolean'">

                </ng-container>

                <ng-container *ngSwitchCase="'String'">
                    <ng-container *ngIf="field.UIControl">
                        <textarea class="form-control" rows="5" [formControl]="control" (blur)="onChange($event)" (keyup)="onKeyup($event)"></textarea>
                    </ng-container>
                    <ng-container *ngIf="!field.UIControl">
                        <input type="text" class="form-control" [formControl]="control" (blur)="onChange($event)" (keyup)="onKeyup($event)">
                    </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'Text'">
                    <textarea class="form-control" rows="5" [formControl]="control" (blur)="onChange($event)" (keyup)="onKeyup($event)"></textarea>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <input type="text" class="form-control" [formControl]="control" (blur)="onChange($event)" (keyup)="onKeyup($event)">
                </ng-container>

            </ng-container>
        </div>
    </div>
</div>